import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/main.scss';
import Footer from './components/Footer';
import { BrowserRouter } from 'react-router-dom';
import * as analytics from './services/analytics';

// Google Analytics
analytics.activate();

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// Render static footer
ReactDOM.render(
    <div className="app__static__footer">
        <Footer />
    </div>,
    document.getElementById('static')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
